import axios from 'axios';

const GENERATION_ENDPOINTS = [
  '/api/openai/chatv2/',
  '/api/openai/dalle-v2/',
  '/api/openai/image-agent/',
  '/api/openai/calendar/generate/',
];

const api = axios.create({
  baseURL: '',
});

api.interceptors.response.use(
  (response) => {
    const url = response.config?.url || '';
    const isGeneration = GENERATION_ENDPOINTS.some(ep => url.includes(ep));
    if (isGeneration && response.status === 200) {
      window.dispatchEvent(new CustomEvent('admind_generation_complete'));
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 402) {
      const data = error.response.data || {};
      window.dispatchEvent(new CustomEvent('admind_limit_exceeded', {
        detail: {
          code: data.code || 'free_limit_exceeded',
          limit_type: data.limit_type || 'tokens',
          has_stripe_customer: data.has_stripe_customer === true,
          current_plan: data.current_plan || null,
        }
      }));
    }
    return Promise.reject(error);
  }
);

export default api;
